import { FormikHelpers } from "formik";
import { useGetDepartment } from "./api/getDepartment";
import { useEditDepartment } from "./api/editDepartment";
import DepartmentEditForm from "./DepartmentEditForm";
import LoadingSpinner from "src/components/Common/UI/LoadingSpinner/LoadingSpinner";


const EditDepartment = ({handleCloseModal, departmentId}: EditDepartmentProps)  => {
  const getDepartmentQuery = useGetDepartment({departmentId: departmentId})
  const editDepartmentMutation = useEditDepartment({data: {}, departmentId});

  const initialValues: IEditDepartmentForm = {
    description: getDepartmentQuery.data?.description ? getDepartmentQuery.data?.description : "",
    placeID: getDepartmentQuery.data?.placeID ? getDepartmentQuery.data.placeID.toString() : "",
    modemID: getDepartmentQuery.data?.modemID ? getDepartmentQuery.data.modemID.toString() : "",
    modemPort: getDepartmentQuery.data?.modemPort ? getDepartmentQuery.data?.modemPort : "",
    unID: getDepartmentQuery.data?.unID ? getDepartmentQuery.data?.unID : "",
    sapCode: getDepartmentQuery.data?.sapCode ? getDepartmentQuery.data?.sapCode : "",
    isEmporiki: getDepartmentQuery.data?.isEmporiki ? getDepartmentQuery.data?.isEmporiki : false,
    isCiti: getDepartmentQuery.data?.isCiti ? getDepartmentQuery.data?.isCiti : false,
    deleted:  getDepartmentQuery.data?.deleted ? getDepartmentQuery.data?.deleted : false,
    filepath: getDepartmentQuery.data?.filepath ? getDepartmentQuery.data?.filepath : "",
    hubType: getDepartmentQuery.data?.hubType ? getDepartmentQuery.data?.hubType : "",
    anetVoice: getDepartmentQuery.data?.anetVoice ? getDepartmentQuery.data?.anetVoice : "",
    comments: getDepartmentQuery.data?.comments ? getDepartmentQuery.data?.comments : "",
  };

  const handleSubmit = async (values: IEditDepartmentForm, { setSubmitting }: FormikHelpers<IEditDepartmentForm>): Promise<void> => {
    try {
      await editDepartmentMutation.mutateAsync({
        data: values,
        departmentId: departmentId
      });
      handleCloseModal();
    }catch(error){
      console.log("values",values)
    } finally {
	    setSubmitting(false);
    }
  }

  if (getDepartmentQuery.isLoading) {
    return (
      <div className="p-5">
        <LoadingSpinner />
      </div>
    )
  }

  if (getDepartmentQuery.error) {
    return (
      <div>Υπήρξε κάποιο πρόβλημα στην ανάκτηση της Διεύθυνσης.</div>
    )
  }

  return (
    <>
      {!getDepartmentQuery.isLoading && getDepartmentQuery.data &&
        <DepartmentEditForm initialValues={initialValues} onSubmit={handleSubmit}  />
      }
    </>
  )
}

interface EditDepartmentProps {
  departmentId: number;
  handleCloseModal: () => void;
}

export default EditDepartment;